var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"homeIndex"},[_c('patch',{attrs:{"data":_vm.data}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/registry.npmmirror.com+vue-loader@13.7.3_krlkgggcd4gw5zlxktysnnpvsm/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21d17be4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.pnpm/registry.npmmirror.com+vue-loader@13.7.3_krlkgggcd4gw5zlxktysnnpvsm/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homeIndex/homeIndex.vue
// module id = null
// module chunks = 